import { useEffect } from "react";

export interface CookiebotConsent {
  stamp: string;
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
  method: "explicit" | null;
}

declare global {
  interface Window {
    Cookiebot?: {
      consent: CookiebotConsent;
    };
  }
}

// Production Cookiebot ID
const COOKIEBOT_ID = "a66e88e1-1611-4956-ab7a-7aa8668c3514";

// Initial consent snippet
const CONSENT_SNIPPET = `
gtag("consent", "default", {
  ad_personalization: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  analytics_storage: "denied",
  functionality_storage: "denied",
  personalization_storage: "denied",
  security_storage: "granted",
  wait_for_update: 500
});
gtag("set", "ads_data_redaction", true);
gtag("set", "url_passthrough", true);
`;

export const CookiebotScript = () => {
  useEffect(() => {
    const head = document.head;

    if (!head.querySelector("#Cookiebot")) {
      const cookiebot = document.createElement("script");
      cookiebot.id = "Cookiebot";
      cookiebot.src = "https://consent.cookiebot.com/uc.js";
      cookiebot.dataset.cbid = COOKIEBOT_ID;
      cookiebot.dataset.blockingmode = "manual";
      cookiebot.type = "text/javascript";
      head.append(cookiebot);
    }

    if (!head.querySelector("#gtag-consent-config")) {
      const consent = document.createElement("script");
      consent.id = "gtag-consent-config";
      consent.dataset.cookieconsent = "ignore";
      consent.innerHTML = CONSENT_SNIPPET;
      head.append(consent);
    }
  }, []);

  return null;
};

/**
 * Pass a function to this one to defer running until after the user
 * has accepted statistics cookies (ie _ga that growthbook depends on).
 */
export function runAfterCookiebotStatisticsAccepted(run: () => void) {
  if (typeof window === "undefined") {
    return;
  }

  const done = () => {
    window.removeEventListener("CookiebotOnAccept", done);
    if (window.Cookiebot?.consent?.statistics === true) {
      run();
    }
  };

  // If Cookiebot already finished, run immediately.
  if (window.Cookiebot?.consent?.statistics === true) {
    run();
  } else {
    window.addEventListener("CookiebotOnAccept", done, { once: true });
  }
}
